import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RoutePaths } from '@shared/utils/route.utils.ts';
import LiveTv from './pages/live-tv/live-tv.tsx';
import Music from './pages/music/music.tsx';
import Series from './pages/series/series.tsx';
import Radio from './pages/radio/radio.tsx';
import Movies from './pages/movies/movies.tsx';
import Playlists from './pages/playlists/playlists.tsx';

const EntertainmentComponent = lazy(() => import('./entertainment.tsx'));

export const entertainmentRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <EntertainmentComponent />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={RoutePaths.Core.Entertainment.LiveTv.absolutePath}
            replace
          />
        )
      },
      {
        path: RoutePaths.Core.Entertainment.LiveTv.path,
        element: (
          <Suspense>
            <LiveTv />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Entertainment.Movie.path,
        element: (
          <Suspense>
            <Movies />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Entertainment.Series.path,
        element: (
          <Suspense>
            <Series />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Entertainment.Music.path,
        element: (
          <Suspense>
            <Music />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.Entertainment.Radio.path,
        element: (
          <Suspense>
            <Radio />
          </Suspense>
        )
      },

      {
        path: RoutePaths.Core.Entertainment.Playlists.path,
        element: (
          <Suspense>
            <Playlists />
          </Suspense>
        )
      }
    ]
  }
];
